module.exports = __webpack_public_path__ + "img/barImg.39979f52.svg";